module.exports = __webpack_public_path__ + "img/sign-in-with-google.2c08eb11.png";